import React, { useEffect } from "react";
import helper from "../../utils/helper";
import Lineliff from "../../components/LineLiff"
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import _ from 'lodash'
import { useNavigate } from "react-router-dom";
import moment from "moment"

const path = window.location.pathname
const PAGE_LIFF_ID = helper.getLiffIdByENV(path, 'dev');;

const Authprofile = (props) => {
  let navigate = useNavigate();
  const cbLineLiff = (e) => {
    // alert(JSON.stringify(e))
    const currentDate = moment(moment().format('YYYY-MM-DDT00:00:00.000')+'Z')
    let expiryDate = null
    let timeover = -1

    if (e && e.expiryDate) {
      expiryDate = moment(e.expiryDate)
      timeover =  expiryDate.diff(currentDate, 'day')
      console.log('e currentDate >>', moment().format('YYYY-MM-DDT00:00:00.000')+'Z')
      console.log('e expiryDate >>', e.expiryDate)
      console.log('e timeover >>', timeover)
    }
    // alert(JSON.stringify(e))
    const queryCache = helper.GEN.queryCache()
    if (e && e.memberId && e.memberStatus == 2 && e.memberPayment?.paymentStatus == 2 && (timeover >= 0 || e.expiryDate == null)) {
      // alert('แล้ว')
      navigate(`/check-in` + queryCache)
    } else if (e && e.memberId && [1,2].includes(e.memberStatus)) {
      // alert('แล้ว')
      navigate(`/profile` + queryCache)
    } else {
      // alert('ไปสมัคร')
      navigate(`/register` + queryCache)
    }
  }
  const handleClose = () => {}
  return (
    <div className="info-value">
      <Lineliff liffId={PAGE_LIFF_ID} callBack={cbLineLiff} isGetLocation={true} />
      <Backdrop sx={{ color: '#fff' }} open={true} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};
export default Authprofile;
